import { useSelector } from 'react-redux';
import React from 'react';

import ChangePassword from './changesPassword';
import ChangePasswordMobile from './changesPasswordMobile';
import ContainerSectionMobile from '../../components/containerSectionMobile';
import ContainerSectionDesktop from '../../components/containerSectionDesktop';

import './profileScreen.scss';

const ProfileScreen = () => {
  const isMobileDevice = useSelector((state) => state.mediaQuery.isMobileDevice);

  return (
    isMobileDevice ? (
      <ContainerSectionMobile className="profile-information">
        <ChangePasswordMobile />
      </ContainerSectionMobile>
    ) : (
      <ContainerSectionDesktop>
        <ChangePassword />
      </ContainerSectionDesktop>
    )
  );
};

export default ProfileScreen;
